var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { object } from '../../../utils/serializr/schema/object';
import { Reward } from '../reward/Reward';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
export class CycleEndStore {
    parent;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    reward;
    get previewImage() {
        if (this.question.inner.local.traitOf.video) {
            const youtubeId = this.question.inner.local.traitOf.video.value.youtubeId;
            if (youtubeId) {
                return `https://img.youtube.com/vi/${youtubeId}/default.jpg`;
                /*
                https://img.youtube.com/vi/<insert-youtube-video-id-here>/hqdefault.jpg
        There is also a medium quality version of the thumbnail, using a url similar to the HQ:
        
        https://img.youtube.com/vi/<insert-youtube-video-id-here>/mqdefault.jpg
        For the standard definition version of the thumbnail, use a url similar to this:
        
        https://img.youtube.com/vi/<insert-youtube-video-id-here>/sddefault.jpg
        For the maximum resolution version of the thumbnail use a url similar to this:
        
        https://img.youtube.com/vi/<insert-youtube-video-id-here>/maxresdefault.jpg
        
                 */
            }
        }
        if (this.question.inner.regional.activeOf.image) {
            return this.question.inner.regional.activeOf.image.img.src;
        }
        return '';
    }
    set previewImage(p) { }
    static get serializeInfo() {
        return {
            props: {
                reward: withDefault(object(Reward, { parentDepth: 2 }), {}),
                previewImage: true,
            },
        };
    }
}
__decorate([
    editable()
], CycleEndStore.prototype, "reward", void 0);
__decorate([
    memoize
], CycleEndStore, "serializeInfo", null);
